var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.appSavitarna)?_c('div',{class:_vm.wraperClass},[_vm._t("default")],2):_vm._e(),(!_vm.appSavitarna)?_c('v-alert',{attrs:{"dense":"","outlined":"","type":"error"}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }